import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

import { ref, onMounted, computed } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';

import { TABS } from '@V/invoice/src/constants';
import { RouteQuery } from '@V/invoice/src/types';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'dbgys-invoice-main',
  setup(__props) {

const route = useRoute();

const routeQuery = route.query as RouteQuery;

const tab = ref();

const curCmopt = computed(() => {
  return TABS[tab.value]?.cmpt;
});
/* 对应角色设置tab */
const tabs = computed(() => {
  return [TABS[1], TABS[2]]; // TABS[5] 去掉代缴税金
});

onMounted(async () => {
  tab.value = +routeQuery.tab ? +routeQuery.tab : tabs.value[0].value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (tabs.value.length > 1)
      ? (_openBlock(), _createBlock(_unref(BaseTabs), {
          key: 0,
          style: {"margin":"10px 0"},
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item) => {
              return (_openBlock(), _createBlock(_unref(BaseTabPane), {
                label: item.label,
                name: item.value,
                key: item.value
              }, null, 8, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(curCmopt.value)))
  ]))
}
}

})